import "es6-promise/auto";
import Vue from "vue";
import Element from "element-ui";
import VueIntercom from "vue-intercom";
import "../node_modules/@mdi/font/scss/materialdesignicons.scss";
import locale from "element-ui/lib/locale/lang/en";
import Vuebar from "vuebar";
import VueLazyload from "vue-lazyload";
import vClickOutside from "v-click-outside";
import VueResize from "vue-resize";
import "vue-resize/dist/vue-resize.css";
import 'xe-utils'
import VueI18n from 'vue-i18n'
import VXETable from 'vxe-table'
import enUS from 'vxe-table/lib/locale/lang/en-US'
import 'vxe-table/lib/style.css'
import VueFloatLabel from "vue-float-label";
import * as VueGoogleMaps from "vue2-google-maps";
import { StatusIndicator } from "vue-status-indicator";
import VuePerfectScrollbar from "./components/vue-ps";
import AudioVisual from "vue-audio-visual";
import { VueCsvImportPlugin } from "vue-csv-import/src";
import "./assets/scss/global.scss";
import "flex.box";
import "animate.css";
import svg from "v-svg";
import Affix from "./directives/affix";
import "./registerServiceWorker";
import { ObserveVisibility } from "vue-observe-visibility";
import VueRecord from "vue-recorder-no-tonejs";
import VueMeta from 'vue-meta';
import './styles.scss';
import batchDirective from './directives/batch.directive';
import { EventBusService } from './services/event-bus.service';
import VueMask from 'v-mask';


const App_vue_1 = require("./App.vue");
const vue_1 = require("vue");
const router_1 = require("./router");
const store_1 = require("./vuex/store");

Vue.prototype.$eventBusService = new EventBusService();

Vue.directive('batch', batchDirective);
//Meta
Vue.use(VueMeta);

Vue.use(VueRecord);

const VueInputMask = require('vue-inputmask').default
Vue.use(VueInputMask);

//i18n for translating vxe table stuff.
Vue.use(VueI18n);

Vue.use(VueMask, {
  placeholders: {
    'X': /[0-9Xx]/
  }
});

const messages = {
  en_US: {
    ...enUS
  }
}

const i18n = new VueI18n({
  locale: 'en_US',
  messages,
})

//vxe table
VXETable.setup({
  i18n: (key, args) => i18n.t(key, args)
});

Vue.use(VXETable);

Vue.config.productionTip = false

Vue.use(svg, {
  filepath: "/voxo-icons.svg",
  prefix: "Vox-icon-",
  class: "voxo-icons",
  size: "20"
});
Vue.component("StatusIndicator", StatusIndicator);

Vue.use(VueCsvImportPlugin);

Vue.directive("observe-visibility", ObserveVisibility);

Vue.use(VueIntercom, { appId: "yzwhns7b" });

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_PLACES_KEY,
    libraries: "places"
  }
});
Vue.use(VueFloatLabel);
Vue.use(VueResize);
Vue.use(Element, { locale });
Vue.use(vClickOutside);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error:
    "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgNjAwIDYwMCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEuNDE0MjE7Ij48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iNjAwIiBoZWlnaHQ9IjYwMCIgc3R5bGU9ImZpbGw6I2UyZTNlNTsiLz48Y2lyY2xlIGN4PSIzMDAiIGN5PSIzMDAiIHI9IjE1NSIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2Utd2lkdGg6NDdweDtzdHJva2U6I2JjYmRiZjsiLz48cmVjdCB4PSIxNjAiIHk9IjIyMyIgd2lkdGg9IjI3NSIgaGVpZ2h0PSIxNjYiIHN0eWxlPSJmaWxsOiNlM2U1ZTQ7Ii8+PHBhdGggZD0iTTQ0MC41LDM5NC41bC0yODYsMGwwLC0xNzdsMjg2LDBsMCwxNzdaTTE2NS41LDIyOC41bDAsMTU1bDI2NCwwbDAsLTE1NWwtMjY0LDBaIiBzdHlsZT0iZmlsbDojZmZmOyIvPjxwYXRoIGQ9Ik00MDQuNDM0LDE3MC44NzdsLTIzMi45NCwyMzIuOTQxbDM1LjM1NSwzNS4zNTVsMjMyLjk0MSwtMjMyLjk0bC0zNS4zNTYsLTM1LjM1NloiIHN0eWxlPSJmaWxsOiNiY2JkYmY7Ii8+PC9zdmc+",
  loading:
    "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwcHgiICBoZWlnaHQ9IjEwMHB4IiAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQiIGNsYXNzPSJsZHMtcmlwcGxlIiBzdHlsZT0iYmFja2dyb3VuZDogbm9uZTsiPjxjaXJjbGUgY3g9IjUwIiBjeT0iNTAiIHI9IjI4LjY2ODUiIGZpbGw9Im5vbmUiIG5nLWF0dHItc3Ryb2tlPSJ7e2NvbmZpZy5jMX19IiBuZy1hdHRyLXN0cm9rZS13aWR0aD0ie3tjb25maWcud2lkdGh9fSIgc3Ryb2tlPSIjNGE1OTZhIiBzdHJva2Utd2lkdGg9IjIiPjxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InIiIGNhbGNNb2RlPSJzcGxpbmUiIHZhbHVlcz0iMDszMCIga2V5VGltZXM9IjA7MSIgZHVyPSIyIiBrZXlTcGxpbmVzPSIwIDAuMiAwLjggMSIgYmVnaW49Ii0xcyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiPjwvYW5pbWF0ZT48YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJvcGFjaXR5IiBjYWxjTW9kZT0ic3BsaW5lIiB2YWx1ZXM9IjE7MCIga2V5VGltZXM9IjA7MSIgZHVyPSIyIiBrZXlTcGxpbmVzPSIwLjIgMCAwLjggMSIgYmVnaW49Ii0xcyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiPjwvYW5pbWF0ZT48L2NpcmNsZT48Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSIxNS45ODI4IiBmaWxsPSJub25lIiBuZy1hdHRyLXN0cm9rZT0ie3tjb25maWcuYzJ9fSIgbmctYXR0ci1zdHJva2Utd2lkdGg9Int7Y29uZmlnLndpZHRofX0iIHN0cm9rZT0iIzg5YWRlOCIgc3Ryb2tlLXdpZHRoPSIyIj48YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJyIiBjYWxjTW9kZT0ic3BsaW5lIiB2YWx1ZXM9IjA7MzAiIGtleVRpbWVzPSIwOzEiIGR1cj0iMiIga2V5U3BsaW5lcz0iMCAwLjIgMC44IDEiIGJlZ2luPSIwcyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiPjwvYW5pbWF0ZT48YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJvcGFjaXR5IiBjYWxjTW9kZT0ic3BsaW5lIiB2YWx1ZXM9IjE7MCIga2V5VGltZXM9IjA7MSIgZHVyPSIyIiBrZXlTcGxpbmVzPSIwLjIgMCAwLjggMSIgYmVnaW49IjBzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSI+PC9hbmltYXRlPjwvY2lyY2xlPjwvc3ZnPg==",
  attempt: 1
});
Vue.directive("affix", Affix);
Vue.use(Vuebar);
Vue.component("vue-scroll", VuePerfectScrollbar);

Vue.use(AudioVisual);
Vue.config.productionTip = false;
new vue_1.default({
  i18n,
  router: router_1.default,
  store: store_1.default,
  render: function (h) { return h(App_vue_1.default); }
}).$mount("#app");
